export const ShopHelpLocalKey = {
  CONTACT_FORM: '_local_contact_form',
  ORDER_DETAIL: '_local_shophelp_order'
}
